import { useRecoilState, useResetRecoilState } from "recoil";
import { tempFilterOptionState } from "../recoil/index.ts";

const useFilterOption = (filterState) => {
  const [filterOption, setFilterOption] = useRecoilState(filterState);
  const [tempFilterOption, setTempFilterOption] = useRecoilState(
    tempFilterOptionState
  );
  const resetFilterOption = useResetRecoilState(filterState);
  const resetTempFilterOption = useResetRecoilState(tempFilterOptionState);

  const handleFilterChange = (key) => (e) => {
    setTempFilterOption((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleRangeChange = (startKey, endKey) => (e) => {
    setTempFilterOption((prev) => ({
      ...prev,
      [startKey]: e.target.value[0],
      [endKey]: e.target.value[1],
    }));
  };

  const applyFilterOption = () => {
    setFilterOption(tempFilterOption);
  };

  const revertTempFilterOption = () => {
    setTempFilterOption(filterOption);
  };

  const resetAllFilterOptions = () => {
    resetFilterOption();
    resetTempFilterOption();
  };

  return {
    filterOption: tempFilterOption,
    handleFilterChange,
    handleRangeChange,
    applyFilterOption,
    revertTempFilterOption,
    resetAllFilterOptions,
  };
};

export default useFilterOption;
